module.exports = __webpack_public_path__ + "static/media/screenshot12.67b44d5b.png";